

import React from 'react';


const NOOP = () => ({});















const defaultValue = {
  showCollaborationModal: void 0,
  hideCollaborationModal: void 0,
  showPrivateSettingsModal: void 0,
  hidePrivateSettingsModal: void 0,
  showShareModal: void 0,
  hideShareModal: void 0,
  fetchCollaborationData: NOOP,
  resourceName: void 0,
  members: void 0,
  privateSettings: void 0,
  linkSharingSettings: void 0
};

const CollaborationContext = React.createContext(defaultValue);

export const CollaborationProvider = CollaborationContext.Provider;
export const CollaborationConsumer = CollaborationContext.Consumer;